"use server";

import { cookies } from "next/headers";
import { redirect } from "next/navigation";

const VALID_USERNAME = "Masterotter";
const VALID_PASSWORD = "Nihao2505***";

export async function login(formData: FormData) {
  const username = formData.get("username") as string;
  const password = formData.get("password") as string;

  if (username === VALID_USERNAME && password === VALID_PASSWORD) {
    const cookieStore = await cookies();
    
    // Set a session cookie for 7 days
    cookieStore.set("otterq-session", "active_session", {
      httpOnly: true,
      secure: process.env.NODE_ENV === "production",
      maxAge: 60 * 60 * 24 * 7, // 7 days
      path: "/",
      sameSite: "lax",
    });

    return { success: true };
  }

  return { error: "Invalid credentials" };
}

export async function logout() {
  const cookieStore = await cookies();
  cookieStore.delete("otterq-session");
  redirect("/login");
}
